import { render, staticRenderFns } from "./AffordabilitySettings.vue?vue&type=template&id=59c027e4"
import script from "./AffordabilitySettings.vue?vue&type=script&lang=js"
export * from "./AffordabilitySettings.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports